import alignElement from './align/alignElement';
import alignPoint from './align/alignPoint';

export { alignElement, alignPoint };

export default alignElement;


//////////////////
// WEBPACK FOOTER
// ./~/dom-align/es/index.js
// module id = 119
// module chunks = 0